import { usePageTheme } from "@/hooks/usePageTheme";
import { BACKGROUND_BY_THEME, BORDER_BY_THEME } from "@/utils/pageThemeStyles";
import { HStack } from "@leplein/ui";
import { useRouterState } from "@tanstack/react-router";
import { Suspense, lazy } from "react";
import { useTranslation } from "react-i18next";
import { NavigationHeaderBackAction } from "./BackAction/NavigationHeaderBackAction";

const HelpAction = lazy(() => import("./HelpAction/HelpAction").then((mod) => ({ default: mod.HelpAction })));

const SPOTS_PATH = /^\/qrs\/[a-zA-Z0-9*_-]+\/spots$/;

export const NavigationHeader = () => {
	const { t } = useTranslation("common");
	const theme = usePageTheme();
	const hasBackAction = useRouterState({
		select: (state) => {
			const leafMatch = state.matches[state.matches.length - 1];

			return leafMatch?.status === "success" && SPOTS_PATH.test(leafMatch.pathname);
		},
	});

	return (
		<header className="sticky top-0 z-10 w-full">
			<HStack
				className={`relative justify-between px-6 py-3 border-b ${BACKGROUND_BY_THEME[theme]} ${BORDER_BY_THEME[theme]}`}
			>
				{hasBackAction ? (
					<NavigationHeaderBackAction />
				) : (
					<img alt={t("brandName")} src="/assets/img/logo.svg" width={110} height={16} />
				)}
				<Suspense fallback={null}>
					<HelpAction />
				</Suspense>
			</HStack>
		</header>
	);
};
